<script>
import {ref} from "vue";
import {useWorkerStore} from "@/stores/Worker/Worker";
import axios from "axios";

export default {
    setup() {

        const loading = ref(false);
        const paySlip = ref({details: []});

        const workerStore = useWorkerStore();

        function preview() {
            loading.value = true;
            axios.post(`/payments/paySlip/worker/preview`, workerStore.worker).then((response) => {
                paySlip.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }


        return {
            loading,
            paySlip,
            preview
        }
    },
};
</script>

<template>
        <v-card>
            <v-card-text>
                <v-skeleton-loader
                        v-show="loading"
                        ref="skeleton"
                        :type="'table'"
                        class="mx-auto"
                />
                <pay-slip-component
                        v-show="!loading"
                        :pay_slip="paySlip"
                />
            </v-card-text>
        </v-card>
</template>